import styled from "@emotion/styled";

export const InputSmall = styled.input`
  padding: 3px 12px;
  line-height: 20px;
  border: 1px solid;
  outline: none;
  border: none;
  font-size: 12px;
  border-radius: 3px;
`;
